/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Membership_Confirmations_See_InvoicesInputs */

const en_admin_membership_confirmations_see_invoices = /** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See Invoices`)
};

const nl_admin_membership_confirmations_see_invoices = /** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturen bekijken`)
};

/** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */
const de_admin_membership_confirmations_see_invoices = en_admin_membership_confirmations_see_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */
const es_admin_membership_confirmations_see_invoices = en_admin_membership_confirmations_see_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */
const fr_admin_membership_confirmations_see_invoices = en_admin_membership_confirmations_see_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */
const it_admin_membership_confirmations_see_invoices = en_admin_membership_confirmations_see_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */
const pt_br2_admin_membership_confirmations_see_invoices = en_admin_membership_confirmations_see_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */
const pl_admin_membership_confirmations_see_invoices = en_admin_membership_confirmations_see_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */
const hu_admin_membership_confirmations_see_invoices = en_admin_membership_confirmations_see_invoices;

/** @type {(inputs: Admin_Membership_Confirmations_See_InvoicesInputs) => LocalizedString} */
const ro_admin_membership_confirmations_see_invoices = en_admin_membership_confirmations_see_invoices;

/**
* | output |
* | --- |
* | "See Invoices" |
*
* @param {Admin_Membership_Confirmations_See_InvoicesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_membership_confirmations_see_invoices = /** @type {((inputs?: Admin_Membership_Confirmations_See_InvoicesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Membership_Confirmations_See_InvoicesInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_membership_confirmations_see_invoices(inputs)
	if (locale === "de") return de_admin_membership_confirmations_see_invoices(inputs)
	if (locale === "es") return es_admin_membership_confirmations_see_invoices(inputs)
	if (locale === "fr") return fr_admin_membership_confirmations_see_invoices(inputs)
	if (locale === "nl") return nl_admin_membership_confirmations_see_invoices(inputs)
	if (locale === "it") return it_admin_membership_confirmations_see_invoices(inputs)
	if (locale === "pt-BR") return pt_br2_admin_membership_confirmations_see_invoices(inputs)
	if (locale === "pl") return pl_admin_membership_confirmations_see_invoices(inputs)
	if (locale === "hu") return hu_admin_membership_confirmations_see_invoices(inputs)
	return ro_admin_membership_confirmations_see_invoices(inputs)
});
export { admin_membership_confirmations_see_invoices as "admin.membership_confirmations.see_invoices" }